var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("Ley de protección de datos personales")]),
      _c("p", [
        _vm._v(
          "Declaro que Compañía Peruana de Medios de Pago SAC (Niubiz), me ha informado de manera clara el uso que le dará a mis datos personales, por lo que de manera, expresa, inequívoca, libre e informada autorizo a utilizar mis datos personales, aquellos que pudieran encontrarse en fuentes accesibles para el público o los que hayan sido válidamente obtenidos de terceros, para tratamientos que supongan desarrollo de acciones comerciales, realización de estudios de mercado, la remisión, directa o por intermedio de terceros (vía medio físico, electrónico, llamadas telefónicas, mensajes de texto, WhatsApp, y/o cualquier otro medio de difusión) de publicidad, información, obsequios, ofertas, promociones comerciales de todo tipo (personalizadas o generales) de productos y/o servicios de Niubiz, de otras empresas del grupo y de sus socios estratégicos. Asimismo, como titular de mis datos personales autorizo a Niubiz la cesión, transferencia nacional e internacional y/o comunicación de mis datos personales, a vinculadas, subsidiarias y/o sucursales y entre éstas. Asimismo, se me ha informado que puedo ejercer los derechos que me asisten de acuerdo con Ley de Datos Personales Ley 29733 y Código de Protección y Defensa del Consumidor, pudiendo hacer uso de dichos derechos por cualquiera de los canales que Niubiz ha puesto a mi disposición."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67d0eaa8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d0eaa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-data-protection-law.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-67d0eaa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-data-protection-law.vue
// module chunks = 27